import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=e61e68bc&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61e68bc",
  null
  
)

export default component.exports